(function (angular) {
	'use strict';

	angular
		.module('investorDashboard')
		.controller('DashboardPerformance', [
			'$timeout',
			'globalConfig',
			'DashboardPerformanceService',
			'ReitElementFactory',
			DashboardPerformanceFunction
		]);

	function DashboardPerformanceFunction(
		$timeout,
		globalConfig,
		DashboardPerformanceService,
		ReitElementFactory
	) {
		var dashboard = this;

		dashboard.setActiveMobileColumn = DashboardPerformanceService.setActiveMobileColumn;
		dashboard.toggleViewFormat = DashboardPerformanceService.toggleViewFormat;
		dashboard.toggleTableSection = DashboardPerformanceService.toggleTableSection;
		dashboard.navigateToReitPositionView = DashboardPerformanceService.navigateToReitPositionView;

		dashboard.$onInit = function() {
			dashboard.loadingPerformance = true;
			dashboard.performanceCategories = ['reportingNav', 'notReportingNav'];
			dashboard.currentYearReturnPeriods = [{
				key: 'firstQuarter',
				label: 'Q1'
			},{
				key: 'secondQuarter',
				label: 'Q2'
			},{
				key: 'thirdQuarter',
				label: 'Q3'
			},{
				key: 'fourthQuarter',
				label: 'Q4'
			},{
				key: 'yearToDate',
				label: 'YTD'
			}];
			
			angular.extend(dashboard, globalConfig);

			ReitElementFactory.getReitElementListsForDashboard()
				.then(function(reitElementLists) {
					angular.extend(dashboard, reitElementLists);
				});

			DashboardPerformanceService.getPerformanceData(false).then(function(performanceData) {
				angular.extend(dashboard, performanceData);
				dashboard.loadingPerformance = false;
				dashboard.isFirstQuarter = false;

				if(angular.isDefined(dashboard.accountBreakdown)) {
					dashboard.accountBreakdown.activeMobileColumn = 'All time';
				} else {
					dashboard.accountBreakdown = {};
				}

				if(angular.isDefined(dashboard.currentYearReturns)) {
					angular.forEach(dashboard.currentYearReturnPeriods, function(period) {
						if(angular.isDefined(dashboard.currentYearReturns.allFunds.returnsByQuarter[period.key]) && dashboard.currentYearReturns.allFunds.returnsByQuarter[period.key].currentPeriod) {
							period.currentPeriod = true;
							if (period.key === 'firstQuarter') {
								dashboard.isFirstQuarter = true;
							}
						}
					});
					dashboard.currentYearReturns.activeMobileColumn = 'yearToDate';
					dashboard.currentYearReturns.selectedViewFormat = 'returnAsPercentage';

					$timeout(function() {
						if(angular.isDefined(dashboard.currentYearReturns.reportingNav)) {
							dashboard.currentYearReturns.reportingNav.expanded = true;
						}
					});
				}
				if(angular.isDefined(dashboard.priorYearReturns)) {
					dashboard.priorYearReturns.activeMobileColumn = 'All time';
					dashboard.priorYearReturns.selectedViewFormat = 'returnAsPercentage';
				} else {
					dashboard.priorYearReturns = {};
				}
			});
		};
	}
})(window.angular);